import React from 'react';
import { useDeviceTypeIsMobile } from '@/hooks';
import { DesktopContainer } from './DesktopContainer';
import { MobileContainer } from './MobileContainer';

export default () => {
  const isMobile = useDeviceTypeIsMobile();

  return <>{isMobile ? <MobileContainer /> : <DesktopContainer />}</>;
};

export * from './types';
export * from './hooks';
export * from './components';
